/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkRetrieveAccountLinks} from '../api'

export const useMutationBulkRetrieveAccountLinks = createReactQueryMutationHook('bulkRetrieveAccountLinks', bulkRetrieveAccountLinks)
